import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from 'mui-rff';

import Grid from '@material-ui/core/Grid';

const SeoBlockText = ({ blockName, onBlur, label = 'Text' }) => {
	return (
		<Grid item xs={12}>
			<TextField
				name={`${blockName}.text`}
				label={label}
				variant="outlined"
				size="small"
				multiline
				rows={4}
				onBlur={onBlur}
			/>
		</Grid>
	);
};

SeoBlockText.propTypes = {
	blockName: PropTypes.string.isRequired,
	onBlur: PropTypes.func.isRequired,
	label: PropTypes.string
};

export default SeoBlockText;
